<script setup lang="ts">
/* Placeholder for a list or panel with nothing in it yet.
   The call to action (usually a <Button>) goes in the `action` slot. */
import Icon from '@/components/Icon.vue'
import type { IconName } from '@/components/icons'

withDefaults(defineProps<{ icon?: IconName; title: string; description?: string }>(), {
  icon: 'layers',
})
</script>

<template>
  <div class="empty">
    <span class="iconWrap">
      <Icon :name="icon" :size="24" />
    </span>
    <h3 class="title">{{ title }}</h3>
    <p v-if="description" class="description">{{ description }}</p>
    <div v-if="$slots.action" class="action"><slot name="action" /></div>
  </div>
</template>

<style scoped>
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--space-2xs);
  padding: var(--space-xl) var(--space-md);
}

.iconWrap {
  display: grid;
  place-items: center;
  width: 3rem;
  height: 3rem;
  margin-bottom: var(--space-3xs);
  color: var(--color-accent);
  background-color: var(--color-accent-soft);
  border-radius: var(--radius-full);
}

.title {
  font-size: var(--text-base);
  font-weight: var(--weight-semibold);
}

.description {
  max-width: 46ch;
  font-size: var(--text-sm);
  color: var(--color-text-muted);
}

.action {
  margin-top: var(--space-2xs);
}
</style>
